import { useEffect } from 'react';
import {Link} from 'react-router-dom';
import {Row, Col, Button, Space} from 'antd';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/auth-context';
import { Helmet } from 'react-helmet';

import './styles/Home.css';
import wholesaleDistributionCenter from '../images/wholesale-distribution-center.jpg';
import mailpersonWithPackage from '../images/mailperson-with-package.jpg';
import warehouse from '../images/warehouse.jpg';
import foodAndBev from '../images/food-and-beverage-import.jpg';
import offshoreWorkersNigeria from '../images/offshore-workers-nigeria-1.jpg';
import shippingJapanBeautiful from '../images/shipping-japan-beautiful.jpg';
import hawaiiBeach from '../images/hawaii-beach.jpg';
import walletWithLogo from '../images/wallet-with-logo-3.jpeg';
import homeworkOverseas from '../images/record-keeping.jpg';


const UseCases = () => {

    const auth = useAuth();
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        if(auth.loginDetails) {
          navigate('/transactions')
        }
      }, []);

    return (
        <div>
            <Helmet>
                <link rel="canonical" href={`https://punkypay.com${location.pathname}`} />
                <meta name="robots" content="index, follow" />
            </Helmet>
            <Row justify="center">
                <Col>

                    {/* upgrade your wallet  */}
                    {/* <div className="container">
                        <div className="text-container">
                            <h2 className="auth-title-text"> Versatile and useful. </h2>
                                    
                            <p className="auth-title-text">
                                Punkypay is the <Link class="light-blue" to="/cost-breakdown">cheapest and fastest</Link> way of paying someone internatioanlly. 
                            </p>
                            <p className="auth-title-text">
                                How will Punkypay help you?
                            </p>
                        </div>
                        <div className="image-container">
                            <img src={walletWithLogo} alt="walletOfFuture"/>
                        </div>
                    </div>  */}
                    {/* 
                        Upgrade your business. 
                        There are so many use cases for Punkypay that we can't mention every one of them.
                        How will Punkypay help your business?
                        MAYBE THROW IN A LINK TO SALES@PUNKYPAY.COM, AFTER I START SELLING THIS
                    */}

                    {/* wholesale distribution */}
                    <div className="container">
                        <div className="text-container">
                            <h2 className="auth-title-text"> Paying Offshore Workers </h2>
                            <p className="auth-title-text">
                                Problem: Your company builds software in Nigeria, but your clients are in the United States. 
                                Wiring money to Nigeria is expensive. 
                                To send $5,000 it would cost $315 - between outbound wiring fees, incoming wiring fees, and exchange rate fees. 
                            </p>
                            <p className="auth-title-text">
                                Solution: Punkypay can make this transfer for only $5. 
                                Also, the transaction will settle in about 3 minutes so your employees can be paid faster. 
                            </p>
                        </div>
                        <div className="image-container">
                            <img src={offshoreWorkersNigeria} alt="offshore-workers-nigeria"/>
                        </div>
                    </div> 

                    {/* e-commerce business expansion */}
                    <div className="container">
                        <div className="text-container">
                            <h2 className="auth-title-text"> E-Commerce</h2>
                            <p className="auth-title-text">
                                Problem: You love your Korean skincare, but it usually takes 3 weeks for the foreign company to confirm your credit card payment. 
                                The company has to wait for the payment to settle before they send out the shipment.
                            </p>
                            <p className="auth-title-text">
                                Solution: By using Punkypay, your payment settles in just about 3 minutes - so you can get your skincare 3 weeks sooner!
                            </p>
                            {/* <p className="auth-title-text">
                                Suppose you run an e-commerce store and want to expand your product line by sourcing unique items from international suppliers. 
                                You can use Punkypay to pay your overseas suppliers quickly, securely, and at a fraction of the cost compared to traditional bank transfers.
                            </p> */}
                        </div>
                        <div className="image-container">
                            <img src={mailpersonWithPackage} alt="mailpersonWithPackage"/>
                        </div>
                    </div>


                    <div className="container">
                        <div className="text-container">
                        <h2 className="auth-title-text"> Wholesale Distribution </h2>
                            <p className="auth-title-text">
                                Problem: Your repair shop needs to buy bolts in bulk. 
                                The bolts come from Mexico, and while each item is very cheap…the transaction fees cost an additional 8%. 
                            </p>
                            <p className="auth-title-text">
                                By using Punkypay, the fees drop to 1%. 
                                In addition, your order comes faster as the transaction only takes 3 minutes to settle.  
                            </p>
                        </div>
                        <div className="image-container">
                        <img src={wholesaleDistributionCenter} alt="wholesaleDistributionCenter"/>
                        </div>
                    </div> 


                    {/* Hotel and tour payments */}
                    <div className="container">
                        <div className="text-container">
                            <h2 className="auth-title-text"> Hotel and Tour Payments </h2>
                            <p className="auth-title-text">
                                Problem: You’re going on a trip to the Colombian Amazon and you’re paying for your hotel. 
                                You don’t want to pay a 5% surcharge for “transaction fees” 
                            </p>
                            <p className="auth-title-text">
                                Solution: You use Punkypay so you don't need to pay that pesky 5%. 
                                Your merchant also benefits from this, as they get their money immediately. 
                            </p>
                            {/* <p className="auth-title-text">
                                Travelers can use Punkypay to book and pay for hotels, tours, and activities at their destination. 
                                This eliminates the need to carry large amounts of cash or rely on alternative payment methods, streamlining the booking process.
                            </p> */}
                        </div>
                        <div className="image-container">
                            <img src={hawaiiBeach} alt="hawaii-beach"/>
                        </div>
                    </div>

                    {/* manufacturing components */}
                    <div className="container">
                        <div className="text-container">
                            <h2 className="auth-title-text"> Manufacturing Components </h2>
                            <p className="auth-title-text">
                                Problem: Your clothing company needs some fabric. 
                                You like the quality of a specific textile factory in Turkey, but every time you pay it takes weeks before your payment reaches them. 
                                Unfortunately, they can’t ship your order until they’ve received payment. 
                            </p>
                            <p className="auth-title-text">
                                Solution: With Punkypay, your payments settle in about 3 minutes. 
                                This lets you streamline production and increase the profitability of your business. 
                            </p>
                            {/* <p className="auth-title-text">
                                If you're a manufacturer, you may need to import specific components or raw materials from overseas to keep your production running smoothly. 
                                Punkypay ensures that payments are processed rapidly and affordably, allowing you to maintain a competitive edge.
                            </p> */}
                        </div>
                        <div className="image-container">
                            <img src={warehouse} alt="warehouse"/>
                        </div>
                    </div> 

                    {/* Living or Studying Abroad */}
                    <div className="container">
                        <div className="text-container">
                            <h2 className="auth-title-text"> Living or Studying Abroad </h2>
                            <p className="auth-title-text">
                                Problem: You are studying in Canada, and you need money. 
                                One day at the ATM, you realize that the exchange rate is 3% worse than what you see on Google, and you have to pay a $7 international out-of-network fee. Yikes!
                            </p>
                            <p className="auth-title-text">
                                Solution: By using Punkypay, you can get your money into Canada for only 1%. Way better!
                            </p>
                            {/* <p className="auth-title-text">
                                Dealing with the banking system while you're abroad can be slow, expensive, and <i>frustrating</i>. 
                                Trust us, we've been there. 
                            </p>
                            <p className="auth-title-text">
                                Punkypay was originally designed for people living internationally. 
                                Punkypay moves your money overseas in minutes, costs a tiny fraction of what you would otherwise pay, and delivers a much more reliable experience.   
                            </p> */}
                        </div>
                        <div className="image-container">
                            <img src={homeworkOverseas} alt="homework-overseas"/>
                        </div>
                    </div> 

                    {/* food and beverage import */}
                    <div className="container">
                        <div className="text-container">
                            <h2 className="auth-title-text"> Food and Beverage Import </h2>
                            <p className="auth-title-text">
                                Problem: You're buying a few boxes of fine wine from France. 
                                Unfortunately, with a credit card or bank wire, you and the winery are splitting more than 10% in fees. 
                            </p>
                            <p className="auth-title-text">
                                Solution: By using Punkypay, the entire transaction costs just 1%. 
                                In addition, your payment settles in a few minutes rather than a few days - so you can get your wine faster!
                            </p>
                            {/* <p className="auth-title-text">
                                Businesses that import specialty food and beverages from abroad can benefit from the speed and cost savings of Punkypay, ensuring a more competitive pricing structure.
                            </p> */}
                        </div>
                        <div className="image-container">
                            <img src={foodAndBev} alt="food-and-beverage-import"/>
                        </div>
                    </div> {/* end container */}

                    <div className="container">
                        <div className="text-container">
                            <h2 className="auth-title-text"> How will Punkypay help you? </h2>
                            <p className="auth-title-text">
                                We'd love to hear how you want to use Punkypay, so shoot us an <a class="light-blue" href="mailto:support@punkypay.com">email here</a>!
                            </p>
                        </div>
                        <div className="image-container">
                            <img src={shippingJapanBeautiful} alt="shipping-japan-beautiful"/>
                        </div>
                    </div>
                    {/* dropshipping */}
                    {/* <div className="container">
                        <div className="text-container">
                            <h2 className="auth-title-text"> Dropshipping </h2>
                            <p className="auth-title-text">
                                If you're involved in dropshipping, where you source products from international suppliers and sell them online without holding inventory, Punkypay can facilitate faster and more cost-effective payments to your suppliers.
                            </p>
                        </div>
                        <div className="image-container">
                            <img src={shippingJapanBeautiful} alt="shipping-japan-beautiful"/>
                        </div>
                    </div>  */}

                </Col>
            </Row>
        </div>
    )
}

export default UseCases;

